export function addOrdinalSuffix(number: number) {
  if (typeof number !== "number") {
    return number; // return as is if not a number
  }
  const suffixes = ["th", "st", "nd", "rd"];
  const remainder10 = number % 10;
  const remainder100 = number % 100;

  return (
    number +
    suffixes[
      remainder10 < 4 &&
      remainder10 > 0 &&
      remainder100 !== 11 &&
      remainder100 !== 12 &&
      remainder100 !== 13
        ? remainder10
        : 0
    ]
  );
}

export function getPlacement(
  placement: number | null,
  placementText: string,
): string {
  if (placement) {
    return addOrdinalSuffix(placement);
  } else {
    return placementText;
  }
}
